
import { Button } from "@/components/ui/button";

interface EmptyStateProps {
  onRefresh: () => void;
}

const EmptyState = ({ onRefresh }: EmptyStateProps) => {
  return (
    <div className="text-center py-8">
      <p className="text-gray-600 mb-4">No investment opportunities available at this time.</p>
      <Button onClick={onRefresh} className="mt-4">
        Refresh Data
      </Button>
    </div>
  );
};

export default EmptyState;
